import {signal} from "../fjsc/src/signals.ts";
import {Router} from "./routing/Router.ts";
import {Route} from "./routing/Route.ts";

export const router = signal<Router|null>(null);

export const currentRoute = signal<Route|null>(null);